var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBarWithRequestStatus',{attrs:{"keyword":_vm.keyword,"request-status":_vm.filter.requestStatus,"search-result":_vm.searchResult},on:{"inputKeyword":function($event){_vm.keyword = $event},"inputRequestStatus":_vm.onChangeRequestStatus,"pagination":_vm.pagination,"search":_vm.search}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }